import React from 'react';
import PropTypes from 'prop-types';
import AssetSelectionCard from './AssetSelectionCard';

export default function AssetSelectionList({ assets, onSelect }) {
  if (!assets.length) {
    return (
      <div className="text-center py-4 text-muted">
        <i className="bi bi-search fs-1 bg-secondary bg-opacity-25 rounded-circle p-3 mb-3 d-inline-block" />
        <p className="fw-semibold mb-1">No assets match your search.</p>
        <p className="small mb-0">
          Assets from connected integrations sync automatically on a daily schedule.
          Try a different search term or check Organization settings → Integrations.
        </p>
      </div>
    );
  }

  return (
    <>
      {assets.map(asset => (
        <AssetSelectionCard
          key={asset.id}
          asset={asset}
          onClick={onSelect}
        />
      ))}
    </>
  );
}

AssetSelectionList.propTypes = {
  assets: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelect: PropTypes.func.isRequired
};
